enum ConsultationTypes {
  ON_SITE_VIDEO_CONSULTATION = 7,
  VIDEO_CONSULTATION = 3,
  FACE_TO_FACE_CONSULTATION = 8,
  REVIEW_CONSULTATION = 11,
  IN_CLINIK_CONSULTATION = Number(process.env.REACT_APP_PRIMARY_HEALTH_CHECK_ID),
}

enum StatusIdTypes {
  PREPARE = 1,
  PREPARED = 5,
  STARTED = 6,
  PARKED = 4,
  CLOSED = 2,
  VOID = 3,
}

enum ConsultationStatusTypes {
  Missed = 'M',
  Active = 'A',
  Started = 'S',
}

const LimitNotificationParam = 10;
const DoctorLetterTypeId = [1, 28];
const IS_CONSULTATION = [3, 7, 8, 11];
const IS_TEST = [1, 4];
const STEPPER_ACTIVE_STEPS: any = {
  1: 1,
  2: 5,
  4: 4,
  5: 2,
  6: 3,
};

const GLUCOSE_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #FFA800 0%, #FFA800 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #F76D00 50%, #F76D00 74%, #ffff 74.20%, #ffff 75%, #FF0300 75%, #FF0300 100%)',
  width: '23.5%',
  barPosition: {
    Low: '0.5%',
    Normal: '25.5%',
    'Pre-diabetic': '50.5%',
    Diabetic: '75.5%',
  },
};

const BLOOD_PREASSURE_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #6EC5CF 0%, #6EC5CF 14%, #ffff 14%, #ffff 14.20%, #1B9A48 14.20%, #46D278 28%, #ffff 28%, #ffff 28.20%, #46D278 28.20%, #46D278 42%, #ffff 42%, #ffff 42.20%, #A9D126 42.20%, #A9D126 58%, #ffff 58%, #ffff 58.20%, #FFA800 58.20%, #FFA800 72%, #ffff 72%, #ffff 72.20%, #F76D00 72.20%, #F76D00 86%, #ffff 86%, #ffff 86.20%, #F50000 86.20%, #F50000 100%)',
  width: '14%',
  barPosition: {
    Low: '0%',
    Optimal: '14.2%',
    Normal: '28.2%',
    'High Normal': '43.2%',
    'Grade 1': '58.5%',
    'Grade 2': '72%',
    'Grade 3': '86%',
  },
};

const PULSE_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #FFA800 0%, #FFA800 33%, #ffff 33%, #ffff 33.3%, #46D278 33.3%, #46D278 66.3%, #ffff 66.3%, #ffff 66.6%, #FFA800 66.6%, #FFA800 99.6%, #ffff 99.6%, #ffff 99.9%)',
  width: '33.3%',
  barPosition: {
    Low: '0%',
    Normal: '33.3%',
    High: '66.3%',
  },
};

const TEMPERATURE_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #FFA800 0%, #FFA800 33%, #ffff 33%, #ffff 33.3%, #46D278 33.3%, #46D278 66.3%, #ffff 66.3%, #ffff 66.6%, #FFA800 66.6%, #FFA800 99.6%, #ffff 99.6%, #ffff 99.9%)',
  width: '33.3%',
  barPosition: {
    Low: '0%',
    Normal: '33.3%',
    High: '66.3%',
  },
};

const OXYGEN_SATURATION_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #F76D00 0%, #F76D00 33%, #ffff 33%, #ffff 33.3%, #FFA800 33.3%, #FFA800 66.3%, #ffff 66.3%, #ffff 66.6%, #46D278 66.6%, #46D278 99.6%, #ffff 99.6%, #ffff 99.9%)',
  width: '33.3%',
  barPosition: {
    Critical: '0%',
    Normal: '33.3%',
    High: '66.3%',
  },
};

const BODY_COMPOSITION_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #6EC5CF 0%, #6EC5CF 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #FFA800 50%, #FFA800 74%, #ffff 74.20%, #ffff 75%, #F50000 75%, #F50000 100%)',
  width: '25%',
  barPosition: {
    Low: '0.5%',
    Normal: '25.5%  ',
    High: '50.5%',
    'Very High': '75.5%',
  },
};

const BODY_WEIGHT_RANGE_RAPORT_CONFIG = {
  rangeBarColors:
    'linear-gradient(to right, #6EC5CF 0%, #6EC5CF 24%, #ffff 24.20%, #ffff 25%, #46D278 25%, #46D278 49%, #ffff 49.20%, #ffff 50%, #FFA800 50%, #FFA800 74%, #ffff 74.20%, #ffff 75%, #F50000 75%, #F50000 100%)',
  width: '25%',
  barPosition: {
    Underweight: '0.5%',
    'Normal weight': '25.5%',
    Overweight: '50.5%',
    'Obesity': '75.5%',
  },
};

export const GLUCOSE_UOM_IDS = {
  1: 'mg/dL',
  7: 'mmol/L',
};


export const TEMPERATURE = 'Temperature';
export const BLOOD_PRESSURE = 'Blood Pressure';
export const OXYGEN_AND_PULSE_RATE = 'Oxygen and Pulse Rate';
export const BODY_COMPOSITION = 'Body Composition';
export const BLOOD_GLUCOSE = 'Blood Glucose';

export {
  ConsultationTypes,
  StatusIdTypes,
  LimitNotificationParam,
  DoctorLetterTypeId,
  IS_CONSULTATION,
  IS_TEST,
  STEPPER_ACTIVE_STEPS,
  GLUCOSE_RANGE_RAPORT_CONFIG,
  BLOOD_PREASSURE_RANGE_RAPORT_CONFIG,
  PULSE_RANGE_RAPORT_CONFIG,
  TEMPERATURE_RANGE_RAPORT_CONFIG,
  OXYGEN_SATURATION_RANGE_RAPORT_CONFIG,
  BODY_COMPOSITION_RANGE_RAPORT_CONFIG,
  BODY_WEIGHT_RANGE_RAPORT_CONFIG,
  ConsultationStatusTypes,
};
